import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

import styles from './code-selector.css';

// supported languages to exclude from the menu, but allow as a URL option

const CodeSelector = function (props) {
    const {
        onChangeCode,
        robotType,
        robotArray,
    } = props;
    return (
        <select
            className={styles.languageSelect}
            onChange={onChangeCode}
        >
            {robotArray[0].indexOf(robotType) != -1 ? <option
                key="python"
                value="python"
            >
                Python
            </option> : null}
            {robotArray[1].indexOf(robotType) != -1 ? <option
                key="c"
                value="c"
            >
                C
            </option> : null}
        </select>
    );
};

CodeSelector.propTypes = {
    currentLocale: PropTypes.string,
    label: PropTypes.string,
    onChangeCode: PropTypes.func
};

export default CodeSelector;
